import { render } from "./AreeTematiche.vue?vue&type=template&id=ae04a4b0"
import script from "./AreeTematiche.vue?vue&type=script&lang=ts"
export * from "./AreeTematiche.vue?vue&type=script&lang=ts"
script.render = render

export default script